var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5C8.83123 13.4997 10.1241 13.0541 11.1728 12.234L14.4697 15.531L15.5303 14.4705L12.2333 11.1735C13.0538 10.1247 13.4997 8.83158 13.5 7.5C13.5 4.19175 10.8082 1.5 7.5 1.5C4.19175 1.5 1.5 4.19175 1.5 7.5C1.5 10.8082 4.19175 13.5 7.5 13.5ZM7.5 3C9.98175 3 12 5.01825 12 7.5C12 9.98175 9.98175 12 7.5 12C5.01825 12 3 9.98175 3 7.5C3 5.01825 5.01825 3 7.5 3Z",
    fill: "#1A1A1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.87f52b5755ff9e3f228314700320600b.svg";
export { ForwardRef as ReactComponent };